import React from 'react'
import { Tabs } from 'antd'
import { useNavigate } from 'react-router-dom'
import styled from '@emotion/styled'

const SettingsSidebar = () => {
  const navigate = useNavigate()
  const currentLocation = window.location.pathname.split('/')[2]

  const items = [
    {
      key: 'general',
      label: <TabTitle data-testid='settings-general-tab'>General</TabTitle>
    },
    {
      key: 'delivery',
      label: <TabTitle data-testid='settings-delivery-tab'>Delivery</TabTitle>
    },
    {
      key: 'accounts-and-billing',
      label: (
        <TabTitle data-testid='settings-accounts-and-billing-tab'>
          Accounts and Billing
        </TabTitle>
      )
    },
    {
      key: 'analytics',
      label: (
        <TabTitle data-testid='settings-analytics-tab'>
          Marketing and Analytics
        </TabTitle>
      )
    },
    {
      key: 'users',
      label: <TabTitle data-testid='settings-users-tab'>Users</TabTitle>
    },
    {
      key: 'terms-and-conditions',
      label: (
        <TabTitle data-testid='settings-terms-and-conditions-tab'>
          Terms and Conditions
        </TabTitle>
      )
    }
  ]

  return (
    <Tabs
      type='card'
      defaultActiveKey={currentLocation}
      className='_mb-8'
      onTabClick={(key) => {
        navigate(`/settings/${key}`)
      }}
      items={items}
    />
  )
}

const TabTitle = styled.span`
  font-size: 14px !important;
  padding-right: 16px;
`

export default SettingsSidebar
